// profile/mutations.ts
import Vue from 'vue';
import { MutationTree } from 'vuex';
import {MAFUser, Purchases, UserState, UserTransaction} from './types';
import {User} from 'firebase';
import * as firebase from 'firebase';
import DocumentReference = firebase.firestore.DocumentReference;
import {Lookup} from '@/store/types';

export const mutations: MutationTree<UserState> = {
    setSelf(state, payload: MAFUser | undefined) {

        if (state ) {
            state.self = payload ? new MAFUser( payload ) : undefined;

        }
    },
    setSelfRef(state, payload: DocumentReference | undefined) {
        if (state) {
            state.selfRef = payload ? payload : undefined;
        }
    },
    setPurchases(state, payload: Purchases) {
        if (state) {
            state.purchases = payload.values;
        }
    },
    setTransactions(state, payload: UserTransaction[]) {
        if (state) {
            state.transactions = payload;
        }
    },
    setDiagnosis(state, payload: Lookup | undefined) {
        if (state) {
            state.diagnosis = payload ? payload : undefined;
        }
    },
    setUserType(state, payload: Lookup | undefined) {
        if (state) {
            state.userType = payload ? payload : undefined;
        }
    },
    setDistances(state, payload: Lookup | undefined) {
        if (state) {
            state.distance = payload ? payload : undefined;
        }
    },
    setFunStuff(state, payload: Lookup | undefined) {
        if (state) {
            state.funStuff = payload ? payload : undefined;
        }
    },
    setGroupFunStuff(state, payload: Lookup | undefined) {
        if (state) {
            state.groupFunStuff = payload ? payload : undefined;
        }
    },
    setSignUpPhase(state, payload: number) {
        if (state) {
            if (state.self) {
                state.self.signUpPhase = payload;
            }
        }
    },
};
